import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=11d31a18&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=js&"
export * from "./GroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=11d31a18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d31a18",
  null
  
)

export default component.exports